import { memo } from 'react';

import Styled from '@/components/atomic/atoms/surfaces/header/styled';
import withExposer from '@/hocs/with-exposer';
import useRefTracking from '@/hooks/use-ref-tracking';
import { BasicComponentProps } from '@/typings/generic';

const HeaderComponent: React.FC<BasicComponentProps> = (props) => {
	const ref = useRefTracking<HTMLElement>('header', 'headers');

	return <Styled ref={ref} {...props} />;
};

const Header = memo(withExposer(HeaderComponent, 'header'));

export default Header;
